import { OnChangePlugin as LexicalOnchangePlugin } from '@lexical/react/LexicalOnChangePlugin';
import { EditorState, LexicalEditor } from 'lexical';
import { $generateHtmlFromNodes } from '@lexical/html';
import React from 'react';
import { onChangePluginProps } from '../rich-text-editor';

export const OnChangePlugin = ({
    onChange,
}: onChangePluginProps): JSX.Element => {
    return (
        <LexicalOnchangePlugin
            onChange={(editorState: EditorState, editor: LexicalEditor) => {
                editorState.read(() => {
                    const htmlString = $generateHtmlFromNodes(editor, null);
                    onChange({ content: htmlString, editorState });
                });
            }}
        />
    );
};
